import { RootState } from "../../../store";
import { Schedule2 } from "../../../../services/cloudchipr.api";
import { getV2UsersMeSchedulesSelector } from "../workflows/getV2UsersMeSchedulesSelector";

export const schedulesDataSelector = (
  state: RootState,
): Schedule2[] | undefined => getV2UsersMeSchedulesSelector(state)?.data;
